import React from "react";
import "./Template_2.css";

const Template_2_TopHeader = () => {
  return (
    <div className="Template_2 top-header">
      <div className="Template_2container">
        <div className="Template_2 top-header-content">
          <div className="Template_2 social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
          </div>
          <div className="Template_2 contact-info">
            <span>
              <i className="fas fa-phone"></i> +1-800-123-4567
            </span>
            <span>
              <i className="fas fa-envelope"></i> info@voyagevista.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template_2_TopHeader;
